var map = {
	"./adminprofile/list": [
		1872,
		17
	],
	"./agentprofile/list": [
		1873,
		20
	],
	"./ai_assistant/list": [
		1874,
		23
	],
	"./api_key/list": [
		1875,
		26
	],
	"./canned_answer/list": [
		1876,
		31
	],
	"./client/list": [
		1877,
		34
	],
	"./destination_restrictor/list": [
		1878,
		36
	],
	"./disposition/list": [
		1879,
		39
	],
	"./field/list": [
		1880,
		42
	],
	"./form/list": [
		1881,
		45
	],
	"./form_website/list": [
		1882,
		48
	],
	"./gdpr/list": [
		1883,
		50
	],
	"./invoice/list": [
		1884,
		52
	],
	"./journey/list": [
		1885,
		58
	],
	"./journey_draft/list": [
		1886,
		61
	],
	"./journey_trigger/list": [
		1887,
		62
	],
	"./journey_variable/list": [
		1888,
		65
	],
	"./list/list": [
		1889,
		68
	],
	"./list_file/list": [
		1890,
		71
	],
	"./mail_account/list": [
		1891,
		74
	],
	"./operational_hours/list": [
		1892,
		77
	],
	"./organization/list": [
		1893,
		80
	],
	"./pause/list": [
		1894,
		83
	],
	"./phonenumber_monthly_cost/list": [
		1895,
		86
	],
	"./phonenumber_monthly_cost_parent/list": [
		1896,
		89
	],
	"./phonenumber_purchase/list": [
		1897,
		93
	],
	"./phonenumber_setup_cost/list": [
		1898,
		96
	],
	"./phonenumber_setup_cost_parent/list": [
		1899,
		99
	],
	"./points_system/list": [
		1900,
		103
	],
	"./prepaid_credit/list": [
		1901,
		106
	],
	"./queue/list": [
		1902,
		109
	],
	"./release/list": [
		1903,
		110
	],
	"./signature/list": [
		1904,
		113
	],
	"./skill/list": [
		1905,
		116
	],
	"./sla_policy/list": [
		1906,
		119
	],
	"./sound/list": [
		1907,
		122
	],
	"./stats_alarm/list": [
		1908,
		125
	],
	"./stats_custom_metric/list": [
		1909,
		128
	],
	"./stats_report/list": [
		1910,
		131
	],
	"./stats_widget/list": [
		1911,
		134
	],
	"./superadmin_profile/list": [
		1912,
		137
	],
	"./tag/list": [
		1913,
		140
	],
	"./tariff/list": [
		1914,
		143
	],
	"./tariff_parent/list": [
		1915,
		146
	],
	"./team/list": [
		1916,
		149
	],
	"./text_message_source/list": [
		1917,
		7
	],
	"./time_interval/list": [
		1918,
		153
	],
	"./user/list": [
		1919,
		156
	],
	"./voice_asterisk/list": [
		1920,
		159
	],
	"./voice_asterisk_downgrade/list": [
		1921,
		162
	],
	"./voice_recording_transcript_setting/list": [
		1922,
		166
	],
	"./voice_route/list": [
		1923,
		169
	],
	"./voice_shortcut/list": [
		1924,
		172
	],
	"./voice_trunk/list": [
		1925,
		175
	],
	"./voice_voicemail/list": [
		1926,
		178
	],
	"./wallboard/list": [
		1927,
		181
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1855;
module.exports = webpackAsyncContext;